import React, { useRef } from 'react';

const HERO_CUTOUT = 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/940lh1kj_5L8A4639.JPG';

export default function Hero() {
  const wrapRef = useRef(null);

  const handleLoad = (e) => {
    const img = e.currentTarget;
    if (wrapRef.current && img.naturalWidth && img.naturalHeight) {
      // Crop top 30% + bottom 10% → show 60% middle band
      const newAspect = (img.naturalWidth / img.naturalHeight) / 0.6;
      wrapRef.current.style.aspectRatio = `${newAspect}`;
    }
  };

  return (
    <section className="relative bg-cream overflow-hidden">
      <div ref={wrapRef} className="w-full overflow-hidden" style={{aspectRatio: '1 / 1'}}>
        <img
          src={HERO_CUTOUT}
          alt="Mariah Angeliq"
          onLoad={handleLoad}
          className="w-full h-full object-cover"
          style={{objectPosition: 'center 75%'}}
        />
      </div>
    </section>
  );
}
